// Campus photo for /colleges/tufts-university: CC BY-SA 4.0, by Swampyank, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ABallou_Hall_at_Tufts_University_in_Medford_Massachusetts_USA_built_in_1852_by_Gridley_JF_Bryant.jpg), checked 2026-10-01 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/tufts-university/; credited under the photo.
const photo = {
    "slug": "tufts-university",
    "alt": "Ballou Hall and the Jumbo statue in winter snow on the Medford campus of Tufts University in Massachusetts",
    "src": "/colleges/tufts-university/campus-1600.webp",
    "srcSmall": "/colleges/tufts-university/campus-800.webp",
    "srcMid": "/colleges/tufts-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/tufts-university/og.jpg",
    "title": "Ballou Hall at Tufts University in Medford Massachusetts USA built in 1852 by Gridley JF Bryant",
    "author": "Swampyank",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ABallou_Hall_at_Tufts_University_in_Medford_Massachusetts_USA_built_in_1852_by_Gridley_JF_Bryant.jpg",
    "read": "2026-10-01"
};

export default photo;
